import { FC, useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { PageParamsContext } from '../../../modules/context/PageContext';
import { phoenixPpv5Services } from '../../../modules/graphql/index';
import { localServicesMockUXL } from '../__mock__/LocalServicesMock';
import { LocalServicesDataProps } from '../LocalServices.types';

export const LocalServicesData: FC<LocalServicesDataProps> = ({ isAuthorMode = false, onLocalServicesDataFetched }) => {
  const isServer = !(typeof window != 'undefined' && window.document);
  const { preProcessorResponse, sessionID, requestId, lang } = useContext(PageParamsContext);

  let { data, loading } = useQuery(phoenixPpv5Services, {
    errorPolicy: 'all',
    fetchPolicy: isServer ? 'network-only' : 'cache-first',
    variables: {
      propertyId: preProcessorResponse?.marsha ?? '',
    },
    context: {
      headers: {
        'accept-language': lang ?? 'en-US',
        'x-b3-traceId': sessionID ?? 'fallback-token',
        'x-b3-spanId': requestId !== '' ? requestId : `${Date.now()}`,
        'correlation-id': sessionID ?? 'fallback-token',
      },
    },
    skip: isAuthorMode,
  });

  if (isAuthorMode) {
    loading = false;
    data = localServicesMockUXL.data;
  }

  useEffect(() => {
    if (!loading && data) {
      onLocalServicesDataFetched({ ...data });
    }
  }, [loading, data, onLocalServicesDataFetched]);

  return null;
};
